import { render, staticRenderFns } from "./BillingSCASettings.vue?vue&type=template&id=c7c1f5b0"
import script from "./BillingSCASettings.vue?vue&type=script&lang=ts"
export * from "./BillingSCASettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,CancelSCAPlan: require('/app/components/Billing/UI2/CancelSCAPlan.vue').default,ZAccordionItem: require('/app/components/zeal/ZAccordionItem/ZAccordionItem.vue').default,ZAccordion: require('/app/components/zeal/ZAccordion/ZAccordion.vue').default})
